import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import * as cn from 'classnames';

import { Icon } from 'components';
import arrowDownCircle from 'assets/svg/arrow-down-circle.svg';
import GamePad from 'assets/svg/gamepad.svg';
import './categorizerControlsStub.scss';
import globalMessages from 'messages';

interface Props {
    handleClick?: () => void;
    isOpen?: boolean;
}

class CategorizerControlsStub extends React.Component<Props> {
    render() {
        const { isOpen } = this.props;

        return (
            <div styleName="container" onClick={this.props.handleClick}>
                <div styleName="title-wrapper ">
                    <Icon styleName="icon-gamepad" glyph={GamePad} />
                    <div styleName="title">
                        <FormattedMessage {...globalMessages.filterText} />
                    </div>
                </div>
                <Icon
                    glyph={arrowDownCircle}
                    styleName={cn('icon', { 'is-open': isOpen })}
                />
            </div>
        );
    }
}

export default CategorizerControlsStub;
